 export default {
	 state: {
		 total_time: [],
		 safety: [],
		 mustering: [],
		 zone_time: {},
		 travel_time: [],
		 first_starts: [],
		 project_zone_time: [],
		 certainty_index: {},
		 time_in_work_zone: 0
	 },
	 mutations: {

	 }
 }